<div class="card" [class]="cardClass">
  <div
    class="card-header align-items-center justify-content-between"
    #header
    [class]="{ 'd-none': showHeader === false, 'd-flex': showHeader }"
    (cdkObserveContent)="headerChanged()"
  >
    <ng-content select="[header]"></ng-content>

    <div class="card-header-actions d-inline-flex align-items-center justify-content-center">
      <ng-content select="[actions]"></ng-content>
    </div>
  </div>

  <ng-content select="[inbetween]"></ng-content>

  <div class="card-body" [class]="bodyClasses" [ngbCollapse]="collapsed">
    <ng-content></ng-content>
  </div>

  <div
    class="card-footer"
    #footer
    [class]="{
      'd-none': showFooter === false,
    }"
    (cdkObserveContent)="footerChanged()"
  >
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
